import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const ComplianceWorkspacePage = lazy(() => import("@/features/dashboard/pages/compliance-workspace"));

export const Route = createFileRoute("/(app)/dashboard/organisation/profile")({
  component: () => (
    <Suspense fallback={<div className="text-muted-foreground text-sm">Loading…</div>}>
      <ComplianceWorkspacePage />
    </Suspense>
  ),
});
